<template>
    <div class="attendance-page">
        <!-- 顶部信息区域 -->
        <div class="header">
            <a-row type="flex" align="middle">
                <a-col flex="auto">
                    <div class="course-info">
                        <p class="course-name">
                            <span>{{ attendanceDetail.courseName }}</span>
                            <van-icon
                                v-if="attendanceDetail.status === 1 || (attendanceDetail.isAutoSign && !attendanceDetail.isConfirm)"
                                name="edit" @click="goEditSchedulePlan(attendanceDetail)" color="#1989fa"
                                style="cursor: pointer;" />
                        </p>
                        <p class="p_desc">{{ formatClassTime() }}</p>
                        <p class="p_desc">上课老师： {{ attendanceDetail.teacherName }}</p>
                        <p class="p_desc">所需课时： {{ attendanceDetail.classHour }}</p>
                        <p class="p_desc">是否跨校区： {{ attendanceDetail.isTransCampus ? '是' : '否' }}</p>
                        <p class="p_desc">加班课时： {{ attendanceDetail.overClassHour }}</p>
                        <p class="p_desc">上课内容: {{ attendanceDetail.classContent }}</p>
                    </div>
                </a-col>
            </a-row>
        </div>

        <!-- 附件上传 -->
        <div class="file-upload-section" v-if="!(attendanceDetail.isAutoSign && !attendanceDetail.isConfirm)">
            <div class="file-upload-label">教案</div>

            <!-- 图片/文件混排列表 -->
            <div class="upload-list">
                <div v-for="(item, index) in fileList" :key="index" class="upload-item">
                    <img v-if="item.isImage" :src="item.url" class="upload-thumb" @click="previewItem(index)" />
                    <div v-else class="upload-file" @click="previewItem(index)">
                        <van-icon name="description" class="upload-file-icon" />
                        <span class="upload-file-name">{{ item.name }}</span>
                    </div>
                    <span v-if="item.status === 'uploading'" class="upload-status uploading">上传中</span>
                    <span v-else-if="item.status === 'failed'" class="upload-status failed">上传失败</span>
                    <van-icon v-if="attendanceDetail.status === 1" name="cross" class="upload-del"
                        @click="deleteItem(index)" />
                </div>

                <div v-if="canUpload && fileList.length < 50" class="upload-add-btn" @click="showAddMenu">
                    <van-icon name="plus" />
                </div>
            </div>
            <div class="upload-tip">图片支持批量多选；文件≤50M；共最多50个</div>

            <!-- 文件（PDF/Word）：走原生文件选择器 -->
            <input ref="fileInputRef" type="file" accept=".pdf,.doc,.docx" multiple
                style="display: none;" @change="onNativeFileChange" />
        </div>

        <!-- 添加附件类型选择 -->
        <van-popup v-model:show="showUploadType" position="bottom" round>
            <div class="upload-type-panel">
                <div class="upload-type-title">添加附件</div>
                <van-cell title="图片" label="支持批量多选" is-link clickable @click="onPickType('image')" />
                <van-cell title="文件" label="PDF/Word" is-link clickable @click="onPickType('file')" />
            </div>
        </van-popup>

        <!-- 学生信息区域 -->
        <div class="students-container">
            <div class="student-row" v-for="student in attendanceDetail.studentScheduleList" :key="student.studentScheduleId">
                <div class="student-name">{{ student.studentName }}</div>
                <div class="status-buttons">
                    <button
                        v-for="dict in filteredSignStatusList"
                        :key="dict.dictValue"
                        class="status-btn"
                        :class="{ active: getStudentStatus(student.studentScheduleId) === parseInt(dict.dictValue) }"
                        @click="setStudentStatus(student.studentScheduleId, parseInt(dict.dictValue))"
                    >{{ dict.dictLabel }}</button>
                </div>
            </div>

            <!-- 添加学生的按钮 -->
            <div class="add-student-row" v-if="isMultiSelectMode && attendanceDetail.status === 1"
                @click="showStudent">
                <span>添加学生</span>
                <van-icon name="arrow" />
            </div>
        </div>

        <div class="button-area" v-if="isMultiSelectMode && attendanceDetail.status === 1">
            <div class="multi-button-container">
                <a-button type="primary" @click="cancelMultiSelect" size="large" class="multi-button">
                    取消
                </a-button>
                <a-button type="primary" danger @click="removeSelectedStudents" size="large" class="multi-button">
                    移除
                </a-button>
            </div>
        </div>

        <!-- 加载遮罩 -->
        <van-overlay :show="loadingFlag">
            <div class="loading-wrapper">
                <van-loading size="24px">{{ lodingText }}</van-loading>
            </div>
        </van-overlay>

        <div class="button-area" v-if="!isMultiSelectMode">
            <div class="multi-button-container">
                <a-button type="primary" danger @click="removeSchedulePlan" block size="large"
                    v-if="attendanceDetail.status === 1">
                    删除
                </a-button>
                <a-button type="primary" @click="addAttendanceAction" block size="large"
                    v-if="attendanceDetail.status === 1 && new Date() > parseDate(attendanceDetail.endDateTime)">
                    考勤
                </a-button>
                <a-button type="primary" v-if="attendanceDetail.isAutoSign && !attendanceDetail.isConfirm" danger
                    @click="confirmAttendanceF" size="large" class="multi-button">
                    确认考勤
                </a-button>
            </div>

        </div>

        <van-popup v-model:show="showStudentPicker" position="bottom">
            <!-- 加载遮罩 -->
            <van-overlay :show="addStudentLoading">
                <div class="loading-wrapper">
                    <van-loading size="24px">保存中..</van-loading>
                </div>
            </van-overlay>
            <div style="height: 80vh; overflow-y: auto;">
                <van-search v-model="studentSearchQuery" placeholder="搜索学生姓名" show-action
                    @update:model-value="filterStudents" @cancel="showStudentPicker = false" />
                <van-cell v-for="student in filteredStudentList" :key="student.studentId" :title="student.studentName"
                    :disabled="student.isLocked === 1" @click="selectStudent(student)">
                    <template #label>
                        <van-tag v-if="student.isLocked === 1" type="danger" plain style="margin-top: 2px;">已锁定</van-tag>
                    </template>
                </van-cell>
            </div>
        </van-popup>

        <ScheduleConflictPopup v-model:show="conflictVisible" :message="conflictMessage" :data="conflictData" />

    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { showConfirmDialog, showToast, showImagePreview } from 'vant';
import { uploadFile } from '@/api/oss';
import { getAttendanceDetailByPlanIdForH5, getStudentListByCourse, addStudent, removeSchedulePlan as apiRemoveSchedulePlan, confirmAttendance, addAttendance } from '@/api/schedule';
import { ensureWecomLogin } from '@/utils/wecomAuth';
import * as ww from '@wecom/jssdk';
import { registerWecomApp } from '@/utils/wecom';
import ScheduleConflictPopup from '@/components/ScheduleConflictPopup.vue';
import { parseDate } from '@/utils/common';
import { useDict } from '@/utils/dict';

const route = useRoute();
const router = useRouter();

// 考勤状态字典：sign_status
const { sign_status: signStatusList } = useDict('sign_status');
// 过滤掉"未记录"(1)，只显示上课/请假/旷课
const filteredSignStatusList = computed(() => {
    if (!signStatusList.value) return [];
    return signStatusList.value.filter(dict => {
        return dict && dict.dictValue !== '1' && dict.dictValue !== 1;
    });
});

const addStudentLoading = ref(false);
const loadingFlag = ref(false);
const lodingText = ref('');
const studentSearchQuery = ref('');
const showStudentPicker = ref(false);
const schedulePlanId = ref(undefined);
const attendanceDetail = reactive({});
const studentList = ref([]);
const filteredStudentList = ref([]);
const isMultiSelectMode = ref(false);
const selectedStudents = ref([]);
const signStatusMap = ref({}); // 记录每个学生的考勤状态：2=上课 3=请假 4=旷课
const longPressTimer = ref(null);
const fileList = ref([]);
const selectedFiles = ref([]);
const conflictVisible = ref(false);
const conflictData = ref([]);
const conflictMessage = ref('');

function initData() {
    getSchedulePlan();
}

function showStudent() {
    loadingFlag.value = true;
    lodingText.value = '加载学生列表中...';
    const params = {
        courseId: attendanceDetail.courseId,
        scheduleId: attendanceDetail.scheduleId,
        teachingModel: attendanceDetail.teachingModel,
        grade: attendanceDetail.grade,
        subject: attendanceDetail.subject,
    };
    getStudentListByCourse(params).then(response => {
        showStudentPicker.value = true;
        studentList.value = response;
        filteredStudentList.value = response;
    }).finally(() => {
        loadingFlag.value = false;
    });
}

function filterStudents() {
    const query = studentSearchQuery.value;
    filteredStudentList.value = studentList.value.filter(student =>
        student.studentName.includes(query)
    );
}

function selectStudent(student) {
    if (student.isLocked === 1) {
        showToast('该学员已锁定，需解锁审核通过后才能排课');
        return;
    }
    addStudentLoading.value = true;
    const params = {
        teachingModel: attendanceDetail.teachingModel,
        scheduleId: attendanceDetail.scheduleId,
        subject: attendanceDetail.subject,
        grade: attendanceDetail.grade,
        courseId: attendanceDetail.courseId,
        studentIds: [student.studentId]
    };
    addStudent(params).then(() => {
        getSchedulePlan();
        showStudentPicker.value = false;
    }).catch(err => {
        if (err && err.data && Array.isArray(err.data) && err.data.length > 0) {
            conflictData.value = err.data
            conflictMessage.value = err.msg || '存在排课时间冲突，冲突详情如下：'
            conflictVisible.value = true
        }
    }).finally(() => {
        addStudentLoading.value = false;
    });
}

function getSchedulePlan() {
    getAttendanceDetailByPlanIdForH5(schedulePlanId.value).then(response => {
        Object.assign(attendanceDetail, response);
        // 初始化每个学生的考勤状态：默认上课(2)
        if (response.studentScheduleList) {
            const statusMap = {};
            response.studentScheduleList.forEach(student => {
                // 如果后端已经有考勤状态（上课/请假/旷课）就用后端的，否则默认上课
                // 状态：1=未记录 2=上课 3=请假 4=旷课
                statusMap[student.studentScheduleId] = (student.signStatus && student.signStatus !== 1) 
                    ? student.signStatus 
                    : 2;
            });
            signStatusMap.value = statusMap;
        }
    });
}

// 获取学生考勤状态
function getStudentStatus(studentScheduleId) {
    return signStatusMap.value[studentScheduleId] || 2;
}

// 设置学生考勤状态
function setStudentStatus(studentScheduleId, status) {
    signStatusMap.value[studentScheduleId] = status;
}

function formatClassTime() {
    if (Object.keys(attendanceDetail).length > 0) {
        const startDateTime = attendanceDetail.startDateTime;
        const endDateTime = attendanceDetail.endDateTime;
        const [startDate, startTime] = startDateTime.split(" ");
        const endTime = endDateTime.split(" ")[1];
        const formattedStartTime = startTime.slice(0, -3);
        const formattedEndTime = endTime.slice(0, -3);
        return `${startDate} ${formattedStartTime}-${formattedEndTime}`;
    }
    return '';
}

function goEditSchedulePlan() {
    if (attendanceDetail.isAutoSign) {
        router.push({
            path: '/editAttendance',
            query: {
                schedulePlanId: schedulePlanId.value,
                courseId: attendanceDetail.courseId
            }
        });
    } else {
        router.push({
            path: '/editSchedulePlan',
            query: {
                schedulePlanId: schedulePlanId.value,
                courseId: attendanceDetail.courseId
            }
        });
    }
}

function startLongPress(student) {
    if (attendanceDetail.status !== 1) {
        return;
    }
    longPressTimer.value = setTimeout(() => {
        isMultiSelectMode.value = true;
        if (!selectedStudents.value.includes(student.studentScheduleId)) {
            selectedStudents.value.push(student.studentScheduleId);
        }
    }, 500);
}

function endLongPress() {
    if (attendanceDetail.status !== 1) {
        return;
    }
    clearTimeout(longPressTimer.value);
}

function toggleSelect(studentScheduleId) {
    if (isMultiSelectMode.value) {
        if (selectedStudents.value.includes(studentScheduleId)) {
            selectedStudents.value = selectedStudents.value.filter(id => id !== studentScheduleId);
        } else {
            selectedStudents.value.push(studentScheduleId);
        }
    }
}

function removeSelectedStudents() {
    if (attendanceDetail.studentScheduleList.length <= selectedStudents.value.length) {
        showToast('至少需要保留一个学生');
        return;
    }

    attendanceDetail.studentScheduleList = attendanceDetail.studentScheduleList.filter(
        student => !selectedStudents.value.includes(student.studentScheduleId)
    );
    cancelMultiSelect();
}

function cancelMultiSelect() {
    isMultiSelectMode.value = false;
    selectedStudents.value = [];
}

function removeSchedulePlan() {
    showConfirmDialog({
        message: '确定要删除这条记录吗？'
    }).then(() => {
        const params = {
            schedulePlanId: attendanceDetail.schedulePlanId,
            scheduleId: attendanceDetail.scheduleId
        };
        apiRemoveSchedulePlan(params).then(() => {
            showToast('操作成功');
            getSchedulePlan();
            router.back();
        }).catch(() => {
        });
    }).catch(() => {
    });
}

function confirmAttendanceF() {
    confirmAttendance(attendanceDetail.schedulePlanId).then(() => {
        showToast('操作成功');
        getSchedulePlan();
    }).catch(() => {
    });
}

function addAttendanceAction() {
    // 把每个学生的考勤状态带上
    const studentScheduleList = attendanceDetail.studentScheduleList.map(student => ({
        ...student,
        signStatus: getStudentStatus(student.studentScheduleId)
    }));

    const params = {
        isOver: attendanceDetail.isOver,
        isTransCampus: attendanceDetail.isTransCampus,
        schedulePlanId: attendanceDetail.schedulePlanId,
        teacherId: attendanceDetail.teacherId,
        studentScheduleList: studentScheduleList,
        overClassHour: attendanceDetail.overClassHour,
        annex: selectedFiles.value.join(',')
    };

    showConfirmDialog({
        title: `上课时间为 ${formatClassTime()}，请确认信息无误。`
    })
        .then(() => {
            addAttendance(params).then(() => {
                showToast('操作成功');
                getSchedulePlan();
                router.back();
            }).catch(() => {
            });
        })
        .catch(() => {
        });
}

// ===== 教案附件上传（图片 + PDF/Word）=====
const wecomReady = ref(false);
const fileInputRef = ref(null);
const canUpload = computed(() => attendanceDetail.status === 1 && new Date() > parseDate(attendanceDetail.endDateTime));

/** 企微环境初始化（页面仅企微内打开） */
async function initWecom() {
    if (!/wxwork/i.test(navigator.userAgent)) {
        return;
    }
    try {
        await registerWecomApp({
            jsApiList: ['chooseImage', 'getLocalImgData', 'previewFile']
        });
        wecomReady.value = true;
    } catch (e) {
        console.error('企微JS-SDK注册失败', e);
    }
}

const showUploadType = ref(false);

/** 加号：弹出 图片/文件 选择 */
function showAddMenu() {
    if (!canUpload.value) {
        return;
    }
    if (fileList.value.length >= 50) {
        showToast('教案最多上传50个');
        return;
    }
    showUploadType.value = true;
}

function onPickType(type) {
    showUploadType.value = false;
    if (type === 'image') {
        pickImages();
    } else {
        pickFiles();
    }
}

function pickImages() {
    chooseImagesByJssdk();
}

function pickFiles() {
    if (fileInputRef.value) {
        fileInputRef.value.click();
    }
}

/** 企微：相册多选图片 */
async function chooseImagesByJssdk() {
    if (!wecomReady.value) {
        showToast('企微SDK未就绪，请重试');
        return;
    }
    const remain = 50 - fileList.value.length;
    if (remain <= 0) {
        return;
    }
    // 提前盖遮罩：系统相册关闭时 WebView 重绘会闪白（发生在 JS 回调之前），
    // 先渲染出遮罩帧，让相册关闭后恢复的页面直接是带遮罩的状态
    loadingFlag.value = true;
    lodingText.value = '图片处理中...';
    await nextTick();
    try {
        const res = await ww.chooseImage({
            count: Math.min(9, remain),
            // 强制原图：compressed 返回的是企微缩略图（实测可被压到 66px 宽），
            // 教案/学案初筛与人工复核都依赖清晰度，模糊图会被 AI 误判或无法复核
            sizeType: ['original'],
            sourceType: ['album']
        });
        if (!res || !res.localIds || !res.localIds.length) {
            return;
        }
        let failCount = 0;
        for (const localId of res.localIds) {
            const imgRes = await ww.getLocalImgData({ localId });
            const localData = imgRes && imgRes.localData;
            if (!localData) {
                failCount++;
                continue;
            }
            const file = base64ToFile(localData, `wecom_${Date.now()}_${Math.random().toString(36).slice(2, 8)}.jpg`, 'image/jpeg');
            if (!file) {
                failCount++;
                continue;
            }
            const item = {
                // 用本地 blob url 做预览，避免大 base64 直接塞进 DOM 导致白屏/卡顿
                url: URL.createObjectURL(file),
                file,
                name: file.name,
                isImage: true,
                status: 'uploading',
                message: '上传中...'
            };
            fileList.value.push(item);
            // 传响应式 proxy（fileList 中的条目）而非原始对象，确保状态更新即时生效
            await uploadItem(fileList.value[fileList.value.length - 1]);
            // 每张处理完让出主线程，避免连续 base64 大内存操作卡住渲染
            await new Promise((resolve) => setTimeout(resolve, 0));
        }
        if (failCount > 0) {
            showToast(`有${failCount}张图片读取失败`);
        }
    } catch (e) {
        console.error('企微选图失败', e);
        showToast('选择图片失败');
    } finally {
        loadingFlag.value = false;
    }
}

/** 原生文件选择器：选择 PDF/Word */
function onNativeFileChange(e) {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (!files.length) {
        return;
    }
    const picked = files.slice(0, 50 - fileList.value.length);
    if (picked.length < files.length) {
        showToast(`最多还能添加${picked.length}个`);
    }
    for (const file of picked) {
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        if (!['pdf', 'doc', 'docx'].includes(ext)) {
            showToast(`${file.name || '文件'} 仅支持PDF/Word`);
            continue;
        }
        if (file.size > 50 * 1024 * 1024) {
            showToast(`${file.name || '文件'} 超过50MB`);
            continue;
        }
        const item = {
            url: '',
            file,
            name: file.name,
            size: file.size,
            isImage: false,
            status: 'uploading',
            message: '上传中...'
        };
        fileList.value.push(item);
        // 传响应式 proxy 而非原始对象，确保状态更新即时生效
        uploadItem(fileList.value[fileList.value.length - 1]);
    }
}

function base64ToFile(dataUrl, fileName, mime) {
    try {
        const base64 = String(dataUrl).replace(/^data:[^;]+;base64,/, '');
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        if (typeof File === 'function') {
            return new File([bytes], fileName, { type: mime });
        }
        // 老环境（如旧 iOS WebView）无 File 构造器时回退 Blob，FormData 同样可上传
        return new Blob([bytes], { type: mime });
    } catch (e) {
        console.error('base64转File失败', e);
        return null;
    }
}

/** 上传单个附件（复用 oss uploadFile） */
async function uploadItem(item) {
    try {
        const formData = new FormData();
        formData.append('file', item.file);
        const response = await uploadFile(formData);
        // 图片保留本地 blob 预览（提交只传 ossId，后端自取 url），避免缩略图重载 OSS 造成白屏；
        // 文件无本地预览，用 OSS url 供 previewFile
        if (!item.isImage) {
            item.url = response.url;
        }
        item.status = 'success';
        item.message = '上传成功';
        item.url = response.url;
        item.fileName = response.fileName;
        item.ossId = response.ossId;
        selectedFiles.value.push(response.ossId);
    } catch (error) {
        item.status = 'failed';
        item.message = '上传失败';
        showToast('上传失败，请重试');
        console.error('文件上传失败:', error);
    }
}

function deleteItem(index) {
    if (index >= 0 && index < fileList.value.length) {
        const item = fileList.value[index];
        fileList.value.splice(index, 1);
        // 按 ossId 移除，避免失败/上传中项导致 selectedFiles 与列表 index 错位
        if (item && item.ossId) {
            const idx = selectedFiles.value.indexOf(item.ossId);
            if (idx >= 0) {
                selectedFiles.value.splice(idx, 1);
            }
        }
    }
}

function previewItem(index) {
    const item = fileList.value[index];
    if (!item) {
        return;
    }
    if (item.isImage) {
        showImagePreview([item.url]);
    } else if (wecomReady.value && item.url) {
        ww.previewFile({ url: item.url, size: item.size || 0, name: item.name });
    } else {
        showToast('文件已上传，可在后端查看');
    }
}

async function initPage() {
    if (route.query.state) {
        schedulePlanId.value = route.query.state;
    } else {
        schedulePlanId.value = route.query.schedulePlanId;
    }
    await ensureWecomLogin(route.query.code);
    initData();
}

onMounted(() => {
    initPage();
    initWecom();
});
</script>

<style scoped>
.attendance-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f8f8f8;
    padding: 16px;
}

.header {
    background-color: #ffffff;
    padding: 16px;
    border-radius: 6px;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;
}

.course-info {
    margin-bottom: 8px;
}

.course-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #333;
    font-weight: bolder;
}

.students-container {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    padding: 16px;
    background-color: #f5f7fa;
}

.student-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.student-name {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.status-buttons {
    display: flex;
    gap: 10px;
}

.status-btn {
    padding: 8px 16px;
    border: 1px solid #ebedf0;
    border-radius: 20px;
    background-color: #fff;
    font-size: 14px;
    color: #969799;
    cursor: pointer;
    transition: all 0.2s ease;
}

.status-btn.active {
    background-color: #1989fa;
    border-color: #1989fa;
    color: #fff;
    box-shadow: 0 2px 6px rgba(25, 137, 250, 0.3);
}

.add-student-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: #ecf5ff;
    border: 1px dashed #1989fa;
    border-radius: 12px;
    color: #1989fa;
    font-size: 16px;
    cursor: pointer;
}

.student-name {
    font-size: 16px;
    color: #333;
    user-select: none;
}

.button-area {
    margin-top: 10px;
    flex-shrink: 0;
    background-color: transparent;
}

.multi-button-container {
    background-color: transparent;
    display: flex;
    gap: 10px;
    width: 100%;
}

.multi-button {
    flex: 1;
}

.p_desc {
    font-size: 14px;
    color: #444;
}

.add-student-card {
    background-color: #e6f7ff;
    /* 蓝色背景以示区别 */
}

.loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}


/* 附件上传区域 */
.file-upload-section {
    padding: 16px;
    background-color: #fff;
    margin-top: -1px;
}

.file-upload-label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
    display: block;
}

/* 教案附件上传（图片 + 文件混排） */
.upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.upload-item {
    position: relative;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: #f7f8fa;
}

.upload-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.upload-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 4px;
    padding: 4px;
    box-sizing: border-box;
}

.upload-file-icon {
    font-size: 28px;
    color: #1989fa;
}

.upload-file-name {
    font-size: 10px;
    color: #666;
    text-align: center;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.upload-del {
    position: absolute;
    top: 0;
    right: 0;
    padding: 2px;
    font-size: 14px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0 0 0 4px;
}

.upload-status {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 10px;
    color: #fff;
    text-align: center;
    padding: 2px 0;
}

.upload-status.uploading {
    background: rgba(0, 0, 0, 0.4);
}

.upload-status.failed {
    background: #ee0a24;
}

.upload-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    font-size: 28px;
    color: #969799;
    background: #f7f8fa;
    border: 1px dashed #c8c9cc;
    border-radius: 8px;
    cursor: pointer;
}

.upload-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #969799;
}

/* 添加附件类型选择弹层 */
.upload-type-panel {
    padding-bottom: env(safe-area-inset-bottom);
}

.upload-type-title {
    padding: 16px 16px 8px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    text-align: center;
}
</style>